module.exports = __webpack_public_path__ + "static/wireframe-mob-c1a1eb01e332c781c72258a5ab94645e.png";